import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Industries from "../components/Industries";
import Recommendations from "../components/Recommendations";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { Toaster } from "../components/ui/sonner";

export default function Home() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="page-home">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Industries />
        <Recommendations />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            border: "1px solid #D1CEC7",
            borderRadius: 0,
            background: "#FFFFFF",
            color: "#1F2326",
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}
